export default __webpack_public_path__ + "static/media/ios-qrcode.1c878f87.png";